import { createContext, useContext } from "react";

const PaginationContext = createContext();

export const PaginationProvider = ({ children, pagination }) => (
    <PaginationContext.Provider value={ pagination }>
        { children }
    </PaginationContext.Provider>
);

export const usePagination = () => {
    const pagination = useContext(PaginationContext);

    return pagination;
};
